// extracted by mini-css-extract-plugin
export default {"controls":"PageControls_controls__arJ+O"};